document.addEventListener('DOMContentLoaded', function () {
  $(document).on("click",".itgcheckout",function(e){
     window.location.href = "/pages/checkout"; 
    return;
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(cart) {
          var customerId = getCustomerId();
          cart['customerId'] = customerId;
         
          console.log(cart);
            var postData = {
             data: cart,
            };
          
            $.ajax({
              url: 'https://prospecbio.online/prospecbio/api/payments', 
              type: 'POST', 
              data: postData, 
              success: function(res) {
                if(res.status){
                
                  if(res.status==true){
                     
                  window.location.href = "https://prospecbio.online/prospecbio/checkouts?id="+res.response; 
                  }
                }
              },
              error: function(error) {
                console.log('Error:', error);
              }
            });

          
        }
    });
      
    });
  
});
 var getCustomerId = function() {
    try {
      let curr = window.ShopifyAnalytics.meta.page.customerId;
    
      if (curr !== undefined && curr !== null && curr !== "") {
        return curr;
      }else{
        return 0;
      }
    } catch(e) { }
    try {
      let curr = window.meta.page.customerId;
      if (curr !== undefined && curr !== null && curr !== "") {
        return curr;
      }
    } catch (e) { }    
    try {
      let curr = _st.cid;
      if (curr !== undefined && curr !== null && curr !== "") {
        return curr;
      }
    } catch (e) { }
    try {
      let curr = ShopifyAnalytics.lib.user().traits().uniqToken;
      if (curr !== undefined && curr !== null && curr !== "") {
        return curr;
      }
    } catch (e) { }
    return null;
  }